import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Badge } from "@vds/badges";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { Modal, ModalTitle, ModalBody } from "@vds/modals";
import { TileContainer } from "@vds/tiles";
import { Title, Body } from "@vds/typography";
import { DeviceContainer } from "./styles";

const PromoCardNew = ({ aemContent, onClick = () => {} }) => {
  const [showModal, setShowModal] = useState(false);
  const isMobile = useMediaQuery({
    query: "(max-width: 445px)",
  });
  const isXSmall = useMediaQuery({
    query: "(max-width: 400px)",
  });

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <>
      <DeviceContainer>
        <Wrapper>
          {!!aemContent?.cta?.isChatIntent && !aemContent?.modal && (
            // if no modal is present, the whole tile can activate chat on click
            <ChatDiv
              id={aemContent?.cta?.isChatIntent ? aemContent?.cta?.link : ""}
              data-lp-link-name={
                aemContent?.cta?.isChatIntent ? aemContent?.cta?.link : ""
              }
            />
          )}
          <TileContainer
            backgroundColor={aemContent?.bgColor ?? "black"}
            padding={isMobile ? "16px 10px 16px 10px" : "24px"}
            onClick={(e) => handleClick(e)}
            width="100%"
            height="100%"
          >
            <TileWrapper>
              <TopSection>
                {!!aemContent?.badge?.text && (
                  <div style={{ width: "fit-content" }}>
                    <Badge fillColor={aemContent?.badge?.color ?? "white"}>
                      {aemContent?.badge?.text}
                    </Badge>
                  </div>
                )}
                {!!aemContent?.title?.text && (
                  <div style={{ marginBottom: "0.25rem" }}>
                    <Title
                      size={aemContent?.title?.size ?? "large"}
                      color={aemContent?.title?.color ?? "white"}
                      bold
                    >
                      {aemContent?.title?.text}
                    </Title>
                  </div>
                )}
                {!!aemContent?.content?.text?.length && (
                  <TileContent>
                    {aemContent?.content?.text.map((item, index) => (
                      <Body
                        key={`promo-body-${index}`}
                        size={aemContent?.content?.size ?? "small"}
                        color={aemContent?.content?.color ?? "white"}
                      >
                        {item}
                      </Body>
                    ))}
                    {aemContent?.modal?.linkText && (
                      <span>
                        <TextLink
                          type="standAlone"
                          size="large"
                          surface={aemContent?.modal?.linkSurface ?? "dark"}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowModal(true);
                          }}
                        >
                          {aemContent?.modal?.linkText}
                        </TextLink>
                      </span>
                    )}
                  </TileContent>
                )}
              </TopSection>
              {!!aemContent?.cta && (
                <BottomSection>
                  {aemContent?.cta?.type === "button" && (
                    <Button
                      size={isXSmall ? "small" : "large"}
                      use={aemContent?.cta?.variant ?? "primary"}
                      surface={aemContent?.cta?.surface ?? "dark"}
                      width="fit-content"
                      onClick={(e) => handleClick(e)}
                    >
                      {aemContent?.cta?.text}
                    </Button>
                  )}
                  {aemContent?.cta?.type === "link" && (
                    <TextLinkCaret
                      surface={aemContent?.cta?.surface ?? "dark"}
                      onClick={(e) => handleClick(e)}
                    >
                      {aemContent?.cta?.text}
                    </TextLinkCaret>
                  )}
                  {!!aemContent?.cta?.isChatIntent && !!aemContent?.modal && (
                    // when modal is present, we need to restrict the chat div to the bottom so that it doesn't cover the modal link
                    <ChatDiv
                      id={
                        aemContent?.cta?.isChatIntent
                          ? aemContent?.cta?.link
                          : ""
                      }
                      data-lp-link-name={
                        aemContent?.cta?.isChatIntent
                          ? aemContent?.cta?.link
                          : ""
                      }
                    />
                  )}
                </BottomSection>
              )}
            </TileWrapper>
          </TileContainer>
        </Wrapper>
      </DeviceContainer>
      {!!aemContent?.modal && (
        <Modal opened={showModal} onOpenedChange={setShowModal}>
          <ModalTitle>{aemContent?.modal?.title}</ModalTitle>
          <ModalBody>
            <ModalBodyContent>
              <Body size="large">{aemContent?.modal?.body}</Body>
              <Button
                width={isMobile ? null : "100px"}
                onClick={(e) => setShowModal(false)}
              >
                {aemContent?.modal?.closeButtonText}
              </Button>
            </ModalBodyContent>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

const Wrapper = styled.div`
  height: 100%;
  @media screen and (min-device-width: 768px) {
    :hover {
      transform: scale(1.02);
    }
  }
`;

const TileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 290px;
`;

const TileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const BottomSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const ChatDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: auto;
`;

export default PromoCardNew;
